var _g, _defs;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgGoogleDrive24 = function SvgGoogleDrive24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#google-drive-24_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.346 19.5c-.269.465-.15.84-.601 1.099a3.04 3.04 0 0 1-1.513.401H6.768c-.54 0-1.06-.142-1.512-.401-.453-.259-.333-.634-.603-1.099L8.515 15h6.97l3.861 4.5Z",
    fill: "#1E88E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.744 3.5c.54-.002 1.06-.359 1.51-.1.452.26.837.635 1.107 1.1l5.232 8.999c.27.465.406.983.407 1.5 0 .52-.638 1.037-.91 1.501l-5.603-1.502L12.001 9 13.744 3.5Z",
    fill: "#FBC02D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 15c0 .52-.136 1.035-.408 1.5l-1.848 3.175c-.267.39-.609.7-1.002.925L15.484 15H22Z",
    fill: "#E53935"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91 16.5C2.639 16.037 2 15.518 2 15s.136-1.036.407-1.502L7.64 4.5c.27-.465.654-.84 1.106-1.1.451-.26.97.098 1.511.099l1.742 5.504-3.485 5.995L2.91 16.5Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.516 15-3.258 5.6a3.038 3.038 0 0 1-1.002-.925L2.408 16.5A2.961 2.961 0 0 1 2 15h6.516Z",
    fill: "#1565C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.253 3.4 12 9 8.742 3.4a3.008 3.008 0 0 1 1.31-.395L13.741 3c.544 0 1.063.14 1.51.4Z",
    fill: "#2E7D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "google-drive-24_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 3)",
    d: "M0 0h20v18H0z"
  })))));
};

export default SvgGoogleDrive24;